module.exports = __webpack_public_path__ + "static/media/monitor-dark.3619539d.svg";